exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-koncerty-js": () => import("./../../../src/pages/koncerty.js" /* webpackChunkName: "component---src-pages-koncerty-js" */),
  "component---src-pages-nase-tvorba-js": () => import("./../../../src/pages/nase-tvorba.js" /* webpackChunkName: "component---src-pages-nase-tvorba-js" */)
}

